import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingAreaAndDateFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingAreaAndDateFields";
import { BuildingClassificationFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingClassificationFields";
import { BuildingExtendedParams } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingExtendedParams";
import { BuildingIdentityFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingIdentityFields";
import { BuildingParameterFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingParameterFields";
import { BuildingValueFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingValueFields";
import {
	type BuildingFormInput,
	type BuildingFormOutput,
	buildingMinimumGroup,
} from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import type { BuildingRealEstateType } from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import { RequiredMinimumMessage } from "web_myplann/Portfolio/PortfolioShared/RequiredMinimumMessage";

type Props = {
	control: Control<BuildingFormInput, unknown, BuildingFormOutput>;
	type: BuildingRealEstateType;
};

const FormResources = Resources.Portfolio.AddRealEstate;

export const BuildingEditFormFields = ({ control, type }: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">
				{t(FormResources.Sections.basicInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<RealEstateTypeRow mode="locked" value={type} />
				<BuildingIdentityFields control={control} />
				<BuildingAreaAndDateFields control={control} />
				<BuildingExtendedParams disclosurePlacement="top">
					<BuildingParameterFields control={control} type={type} />
				</BuildingExtendedParams>
			</Stack>
			<RequiredMinimumMessage
				control={control}
				fields={buildingMinimumGroup}
				message={t(FormResources.Validations.requiredMinimum)}
			/>

			<Typography variant="sectionLabel">
				{t(FormResources.Sections.values)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<BuildingValueFields control={control} isLast />
			</Stack>

			<BuildingClassificationFields control={control} />
		</>
	);
};
